import { createContext, useContext } from "react";
import type { SessionContext } from "../api/types";

export const SessionContextValue = createContext<SessionContext | null>(null);

export function useSession(): SessionContext {
  const value = useContext(SessionContextValue);
  if (!value) throw new Error("useSession must be used within SessionBoundary");
  return value;
}
